import { getSampleHeaders } from '@/lib/csv-upload/utils/column-utils'
import type { CSVRow } from '@/types/csv-upload'
import { IntegrationSource } from '@super/shared-types'

interface CSVPreviewTableProps {
  headers: string[]
  sampleRows: CSVRow[]
  pmsType: IntegrationSource | ''
  uploadType: 'contacts' | 'properties' | 'units'
  maxColumns?: number
  maxRows?: number
}

export function CSVPreviewTable({
  headers,
  sampleRows,
  pmsType,
  uploadType,
  maxColumns = 4,
  maxRows = 3,
}: CSVPreviewTableProps) {
  const sampleHeaders = getSampleHeaders(
    headers,
    pmsType || IntegrationSource.APPFOLIO,
    maxColumns,
    uploadType,
  )

  const filteredRows = sampleRows
    .filter(row => {
      // Filter out rows that have no meaningful data in the sample headers
      return sampleHeaders.some(header => {
        const value = String(row[header] || '').trim()
        return value.length > 0
      })
    })
    .slice(0, maxRows)

  if (sampleHeaders.length === 0 || filteredRows.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500 text-sm">
        No preview data available
      </div>
    )
  }

  return (
    <div>
      <h4 className="text-sm font-medium mb-2">Sample data:</h4>
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-xs">
          <thead className="bg-gray-50">
            <tr>
              {sampleHeaders.map((header, index) => (
                <th key={index} className="px-2 py-1 text-left font-medium">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row, index) => (
              <tr key={index} className="border-t">
                {sampleHeaders.map((header, colIndex) => (
                  <td key={colIndex} className="px-2 py-1 text-gray-600">
                    {String(row[header] || '').slice(0, 20)}
                    {String(row[header] || '').length > 20 ? '...' : ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
